<template>
  <div class="row">
    <div class="col-lg-12" style="padding: 20px">
      <div class="main-card mb-12 card" style="margin-left: 10px">
        <div style="margin: 20px">
          <ul style="color: #000">
            <li
              v-for="(includes, board) in boards"
              :class="{ active: selBoard === board }"
              v-on:click="
                selBoard = board;
                loadBoard();
              "
              v-bind:key="board"
              style="font-size:20px;important;font-weight:bold; list-style-type: none;"
            >
              <a href="#" data-toggle="tab">{{ board }}</a>
            </li>
          </ul>
          <div class="tab-content">
            <div id="home">
              <h5 class="card-title">학습자료</h5>
              <query-grid :config="config" ref="qg">
                <template #search_main="props">
                  <button
                    class="btn btn-danger btn-sm"
                    style="width: 20%"
                    @click="
                      firstselected = 0;
                      viewSecond();
                      props.callback(firstselected);
                    "
                  >
                    전체</button
                  ><br />
                  <button
                    class="btn btn-warning btn-sm"
                    style="width: 20%; margin: 2px"
                    v-for="firstlist in firstlists"
                    v-bind:key="firstlist.No"
                    @click="
                      firstselected = firstlist.No;
                      viewSecond();
                      props.callback(firstselected);
                    "
                  >
                    {{ firstlist.Main }}
                  </button>
                </template>
                <template #search_sub="props">
                  <select
                    v-model="subselected"
                    @change="
                      viewVol();
                      props.callback(subselected);
                      this.$refs.qg.search();
                    "
                    style="border: 1px solid #ccc; padding: 4px"
                  >
                    <option value>Sub</option>
                    <option
                      v-for="sublist in sublists"
                      :value="sublist.No"
                      v-bind:key="sublist.No"
                    >
                      {{ sublist.Sub }}
                    </option>
                  </select>
                </template>
                <template #search_vol="props">
                  <select
                    v-model="volselected"
                    @change="
                      props.callback(volselected);
                      this.$refs.qg.search();
                    "
                    style="border: 1px solid #ccc; padding: 4px"
                  >
                    <option value>Volume</option>
                    <option
                      v-for="vollist in vollists"
                      :value="vollist.No"
                      v-bind:key="vollist.No"
                    >
                      {{ vollist.Vol }}
                    </option>
                  </select>
                </template>
                <template #actions>
                  <router-link
                    to="articles/new"
                    v-if="this.$root.guiPerm == 'ROOT'"
                    ><button class="btn btn-danger">글쓰기</button></router-link
                  >
                </template>
                <template #items="props">
                  <tr v-for="article in props.records" v-bind:key="article.id">
                    <td>{{ article.id }}</td>
                    <td style="font-weight: bold; padding: 16px 2px">
                      {{ article.main }}
                    </td>
                    <td>{{ article.sub }}</td>
                    <td>
                      <span>{{ article.vol }}</span>
                    </td>
                    <td>
                      <router-link
                        :to="'/boards/files/articles/' + article.id"
                        >{{ article.title }}</router-link
                      >
                    </td>
                    <td>{{ article.writerName }}</td>
                    <td>{{ article.created_at }}</td>
                  </tr>
                </template>
              </query-grid>

              <div style="float: right">
                <router-link
                  to="articles/new"
                  v-if="this.$root.guiPerm == 'ROOT'"
                  ><button class="btn btn-danger">글쓰기</button></router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import QueryGrid from "../components/QueryGrid.vue";
export default {
  components: {
    QueryGrid,
  },
  data: () => ({
    boards: {},
    articles: [],
    selBoard: "",
    search: "",
    firstlists: [],
    firstselected: "",
    subselected: "",
    sublists: [],
    volselected: "",
    vollists: [],
    config: {
      name: "학습자료실",
      req_endpoint: "/boards/files/articles",
      default_limit: 20,
      search_fields: [
        {
          id: "cate_filter_main",
          name: "메인분류",
          type: "custom",
          custom_name: "main",
        },
        {
          id: "cate_filter_sub",
          name: "서브분류",
          type: "custom",
          custom_name: "sub",
        },
        {
          id: "cate_filter_vol",
          name: "볼륨",
          type: "custom",
          custom_name: "vol",
        },
        {
          id: "date_filter",
          name: "날짜검색",
          type: "date",
          filter_type: {
            created_at: "등록일",
            updated_at: "수정일",
          },
        },
        {
          id: "search",
          name: "키워드검색",
          type: "text",
          placeholder: "제목으로 검색",
        },
      ],
      columns: [
        {
          id: "id",
          sortable: true,
          name: "번호",
          excel_print: (v) => {
            return v.id;
          },
        },
        {
          id: "main",
          sortable: true,
          name: "메인분류",
          excel_print: (v) => {
            return v.main;
          },
        },
        {
          id: "sub",
          sortable: true,
          name: "서브분류",
          excel_print: (v) => {
            return v.sub;
          },
        },
        {
          id: "vol",
          sortable: true,
          name: "볼륨",
          excel_print: (v) => {
            return v.vol;
          },
        },
        {
          id: "title",
          sortable: true,
          name: "제목",
          excel_print: (v) => {
            return v.title;
          },
        },
        {
          id: "writerName",
          sortable: true,
          name: "작성자",
          excel_print: (v) => {
            return v.writerName;
          },
        },
        {
          id: "created_at",
          sortable: true,
          name: "등록일",
          excel_print: (v) => {
            return v.created_at;
          },
        },
      ],
    },
  }),
  methods: {
    loadBoard() {
      var extras = "?";
      if (this.search) {
        extras += "&search=" + this.search;
      }
      if (this.volselected) {
        extras += "&cate_filter_type=vol&cate_filter_var=" + this.volselected;
      } else if (this.subselected) {
        extras += "&cate_filter_type=sub&cate_filter_var=" + this.subselected;
      } else if (this.firstselected) {
        extras +=
          "&cate_filter_type=main&cate_filter_var=" + this.firstselected;
      }
      axios.get("/boards/files/articles" + extras).then((response) => {
        if (response.data.error) {
          alert("게시글을 불러올 수 없습니다.\n" + response.data.error);
        } else {
          this.articles = response.data.result.articles;
        }
      });
    },
    viewSecond() {
      /*if(!this.firstselected) {
this.sublists = []
this.vollists = [];
return;
                  };*/

      this.$refs.qg.pushSetting("cate_filter_vol", null);
      this.$refs.qg.pushSetting("cate_filter_sub", null);
      this.volselected = null;
      this.subselected = null;
      axios
        .get("/boards/files_categories/" + this.firstselected)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.sublists = response.data.result;
          }
        });
    },
    viewVol() {
      this.volselected = null;
      this.$refs.qg.pushSetting("cate_filter_vol", null);
      if (!this.subselected) {
        this.vollists = [];
        return;
      }
      axios
        .get(
          "/boards/files_categories/" +
            this.firstselected +
            "/" +
            this.subselected
        )
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.vollists = response.data.result;
          }
        });
    },
  },
  mounted() {
    this.loadBoard();
    axios.get("/boards/files_categories").then((response) => {
      if (response.data.error) {
        $.notify(
          {
            // options
            message: "데이터를 조회할 수 없습니다. " + response.data.error,
          },
          {
            // settings
            type: "danger",
            z_index: 9999,
          }
        );
      } else {
        this.firstlists = response.data.result;
        //console.log(this.firstlists);
      }
    });
  },
};
</script>
